import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import lockIcon from 'resources/img/lock.svg';
import { SeeqLogo2026 } from '@/core/SeeqLogoOrange.atom';
import { getWorkbooksLink } from '@/main/routing.utilities';
import { notifyError } from '@/utilities/screenshot.utilities';
import { faArrowLeft } from '@seeqdev/icons/fa-sharp-regular-svg-icons';
import { Icon } from '@seeqdev/qomponents';

export const Unauthorized = () => {
  const { t } = useTranslation();
  const ownerInfo = useLocation()?.state?.ownerInfo || {};

  useEffect(() => {
    notifyError('Could not load page: the current user is not authorized to view it');
  }, []);

  return (
    <div data-testid="unauthorizedPage" className="unauthorizedSplash fullViewport tw:flex tw:overflow-hidden">
      <div className="tw:flex tw:h-full tw:flex-1 tw:flex-col tw:justify-between tw:px-16 tw:py-14">
        <div data-testid="mainContent">
          <h2 className="tw:mb-2 tw:text-[3.125rem] tw:leading-tight tw:font-semibold">{t('UNAUTHORIZED.TITLE_V2')}</h2>
          <p className="tw:mb-6 tw:text-[1.625rem]">
            {ownerInfo && ownerInfo.name
              ? t('UNAUTHORIZED.CONTACT_SPECIFIC_OWNER', { owner: ownerInfo.name, email: ownerInfo.email })
              : t('UNAUTHORIZED.CONTACT_OWNER')}
          </p>
          <Link
            to={getWorkbooksLink()}
            className="unauthorizedBackLink tw:inline-flex tw:items-center tw:rounded-md tw:px-4 tw:py-2 tw:text-base tw:font-semibold tw:no-underline">
            <Icon icon={faArrowLeft} type="color" color="var(--sq-login-orange)" extraClassNames="mr5" />
            {t('UNAUTHORIZED.BACK')}
          </Link>
        </div>
        <SeeqLogo2026 />
      </div>
      <div className="tw:flex tw:w-[420px] tw:shrink-0 tw:items-center tw:justify-end tw:pr-24">
        <img src={lockIcon} alt="" className="tw:h-[280px] tw:w-[280px]" />
      </div>
    </div>
  );
};
